import React from 'react'

const Searchbtn = () => {
  return (
    <button className='h-11 text-white font-bold px-7 py-3 rounded-[8rem] bg-green-200 bg-gradient-to-r from-tmbdLightGreen to-tmbdLightBlue hover:text-tmdbDarkBlue inline-flex justify-center items-center'>Search</button>
  )
}

export default Searchbtn
